import { defineMessages } from 'react-intl';

export const freightNavigationButtonsMessages = defineMessages({
  navigateToPrevious: {
    defaultMessage: 'Navigate to previous freight shipment',
    id: '8BErKS',
    description: 'Aria label for button that navigates to the previous freight shipment',
  },
  navigateToNext: {
    defaultMessage: 'Navigate to next freight shipment',
    id: 'kfHl4G',
    description: 'Aria label for button that navigates to the next freight shipment',
  },
});
